var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6874_46986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.14005 0 0 3.14005 0 7C0 10.86 3.14005 14 7 14C10.86 14 14 10.86 14 7C14 3.14005 10.86 0 7 0Z",
    fill: "#E981C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5467 5.51666L6.75499 9.30826C6.64124 9.42201 6.49191 9.47926 6.34259 9.47926C6.19327 9.47926 6.04395 9.42201 5.93019 9.30826L4.03439 7.41246C3.80624 7.18442 3.80624 6.8157 4.03439 6.58766C4.26244 6.35951 4.63104 6.35951 4.85919 6.58766L6.34259 8.07106L9.72189 4.69186C9.94994 4.46371 10.3185 4.46371 10.5467 4.69186C10.7747 4.91991 10.7747 5.28851 10.5467 5.51666Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6874_46986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPink);
export default __webpack_public_path__ + "static/media/check-pink.ff60ce455f33b8d601d1cfee52272ca7.svg";
export { ForwardRef as ReactComponent };